import React from 'react';
import PlayerRow from './components/PlayerRow';
import { calculateTeamTotal, getMatchResult } from './utils/matchUtils';

const TeamPanel = ({ squadra, giocatori, falli, fairPlay, onUpdateGiocatore, onToggleCartellino, onUpdateFalli, onUpdateFairPlay, teamNumber, giocatoriSquadra1, giocatoriSquadra2, falli1, falli2, tipoPartita }) => {
  if (!squadra || !giocatori) return null;

  const sortedPlayers = [...giocatori].sort((a, b) => a.n - b.n);
  const matchResult = getMatchResult(giocatoriSquadra1, giocatoriSquadra2, falli1, falli2, tipoPartita, teamNumber);

  // Calcola mete bonus da falli avversari (ogni 3 falli = 1 meta)
  const falliAvversari = teamNumber === 1 ? (falli2 || 0) : (falli1 || 0);
  const meteBonus = Math.floor(falliAvversari / 3);
  const meteBase = calculateTeamTotal(giocatori, 'mete');
  const meteTotali = meteBase + meteBonus;

  const getResultDisplay = (result) => {
    if (!result) return null;
    
    switch (result) {
      case 'win':
        return { text: 'VITTORIA', class: 'match-result-win' };
      case 'loss':
        return { text: 'SCONFITTA', class: 'match-result-loss' };
      case 'draw':
        return { text: 'PAREGGIO', class: 'match-result-draw' };
      default:
        return null;
    }
  };

  const resultDisplay = getResultDisplay(matchResult);

  return (
    <div className="match-squadra-panel">
      <div className="match-squadra-header">
        <h3>{squadra.nome}</h3>
        {resultDisplay && (
          <div className={`match-result ${resultDisplay.class}`}>
            {resultDisplay.text}
          </div>
        )}
      </div>
      
      <div className="match-giocatori-table">
        <div className="match-table-header">
          <div className="match-col-numero">N°</div>
          <div className="match-col-nome">Nome</div>
          <div className="match-col-stat">
            Mete ({meteTotali})
          </div>
          <div className="match-match-col-stat">
            Pieni ({calculateTeamTotal(giocatori, 'pieni')})
          </div>
          <div className="match-col-stat">
            Vuoti ({calculateTeamTotal(giocatori, 'vuoti')})
          </div>
          <div className="match-col-stat">
            Assist ({calculateTeamTotal(giocatori, 'assist')})
          </div>
          <div className="match-col-cartellini">Cartellini</div>
        </div>
        
        <div className="match-players-container">
          {sortedPlayers.map(giocatore => (
            <PlayerRow
              key={giocatore.id}
              giocatore={giocatore}
              onUpdateGiocatore={onUpdateGiocatore}
              onToggleCartellino={onToggleCartellino}
              teamNumber={teamNumber}
            />
          ))}
        </div>
        
        {/* Separatore grafico */}
        <div className="match-team-fouls-separator"></div>
        
        {/* Riga Fair Play: e' un voto da 0 a 10, non un contatore. La casella vuota vuol dire che
            l'arbitro non lo ha assegnato, ed e' diverso da un voto zero: per questo si svuota a
            null e non a zero, altrimenti la partita entrerebbe nella media di squadra. */}
        <div className="match-giocatore-row match-team-fouls-row">
          <div className="match-col-numero"></div>
          <div className="match-col-nome">Fair play</div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-cartellini">
            <input
              type="number"
              min="0"
              max="10"
              aria-label="Fair play"
              value={fairPlay ?? ''}
              onChange={(e) => onUpdateFairPlay(e.target.value === '' ? null : parseInt(e.target.value, 10))}
              className="stat-input match-team-fouls-input"
            />
          </div>
        </div>

        {/* Riga Falli di Squadra */}
        <div className="match-giocatore-row match-team-fouls-row">
          <div className="match-col-numero"></div>
          <div className="match-col-nome">Falli di Squadra</div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-stat"></div>
          <div className="match-col-cartellini">
            <input
              type="number"
              min="0"
              value={falli || 0}
              onChange={(e) => onUpdateFalli(parseInt(e.target.value) || 0)}
              className="stat-input match-team-fouls-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPanel;